// @core/api/endpoints/authz/read_tuples.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReadTuplesRequest,
  ReadTuplesResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Read authorization tuples
 * Retrieves stored relationship tuples matching the specified filter criteria. Returns only explicitly stored tuples without traversing the authorization graph. Supports pagination via continuation_token for large result sets.
 */
export async function ReadTuples(
  data: ReadTuplesRequest,
  options?: RequestOptions
): Promise<ReadTuplesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tuples/read`;
  const requestOptions = options;
  return client.post<ReadTuplesResponse>(requestPath, data, requestOptions);
}
